import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { IssueTypeT } from '@/components/common/menu/lib/types/navigationDataTypes.ts'
import IssuesFiltersDeleteCustomFilterBtn from '@/routes/projectStages/issues/view/filters/customFilter/IssuesFiltersDeleteCustomFilterBtn.tsx'
import { Wand } from 'lucide-react'

export type CustomFiltersT = IssueTypeT[`currentUserCustomFilters`]

export function createCustomFilterProperties(customFilters: CustomFiltersT) {
  customFilters = customFilters ?? []

  let customFiltersProperties: PopoverProperty[] = []

  customFilters.forEach(filter => {
    let customFilterProperty: PopoverProperty = {
      label: filter.name ?? '',
      value: `custom:${filter.queryString}`,
      icon: <Wand className={`size-4`} />,
      secondIcon: <IssuesFiltersDeleteCustomFilterBtn id={filter[`@id`]} />,
      id: filter[`@id`],
    }

    customFiltersProperties.push(customFilterProperty)
  })
  return customFiltersProperties
}
